import {showErrorNotification} from "../../global/notifications";

export default function (){
    return allRequiredFieldsCollected()
}

const allRequiredFieldsCollected = () => {
    const $contractTypeDropDown = $('.js-dropdown-custom[name="ContractType"]');
    const k_contractTypeDropDown = $contractTypeDropDown.data('kendoDropDownList');
    const contractType = k_contractTypeDropDown.value();

    const $requiredFields = $('[data-required=true]').not(':disabled');
    $('.fieldValidationError').removeClass('fieldValidationError');

    let passed = true;

    $.each($requiredFields, (index, element) => {
        const $element = $(element);
        const forContract = $element.data('for-contract-type');

        if (!forContract || forContract.indexOf('ALL') !== -1 || forContract.indexOf(contractType) !== -1) {
            const $element = $(element);
            const value = $element.val();
            
            if (!value || ($element.hasClass('js-dropdown-custom') && value === '-1')) {
                const name = $element.attr('name');
                if (name === 'ExistingContract' && !$('[name="IsForExistingContract"]').prop('checked')) return;
                if (name === 'AttachmentType' && doAttachmentValidation()) return;
                if ((name === 'Project.FullName' || name === 'WorkOrderNumber') && doProjectWorkOrderValidation()) return;
                if (name === 'Software' && !$('[name="IsCertifiedPayrollRequired"]').hasClass("--green")) return;


                if ($element.hasClass('js-dropdown') || $element.hasClass('js-dropdown-custom') || $element.attr('data-role') === 'autocomplete' ||
                    $element.hasClass('js-currency') || $element.hasClass('js-textfield') || $element.hasClass('js-percentage'))
                    $element.parent().addClass('fieldValidationError');
                else $(element).addClass('fieldValidationError');

                passed = false;
            }
        }
    });

    if (!passed) showErrorNotification('Please fill all required fields before submitting form');

    return passed;
}

const doAttachmentValidation = () => {
    const attachments = $('.js-request-attachment-grid').data('kendoGrid').dataSource.data();

    const contractDrawings = attachments.find(attachment => attachment.category === 'Contract Drawings');
    const contractSchedule = attachments.find(attachment => attachment.category === 'Contract Schedule');

    if (!contractDrawings) showErrorNotification('Contract Drawings Attachment Needed');
    if (!contractSchedule) showErrorNotification('Contract Schedule Attachment Needed');

    return contractDrawings && contractSchedule;
}

const doProjectWorkOrderValidation = () => {
    const $project = $('[name="Project.FullName"]');
    const k_project = $project.data('kendoAutoComplete');
    const project = k_project.value();
    const isProjectValid = project !== '';

    const $workOrder = $('[name="WorkOrderNumber"]');
    const k_workOrder = $workOrder.data('kendoAutoComplete');
    const workOrder = k_workOrder.value();
    const isWorkOrderValid = workOrder !== '';

    return isProjectValid || isWorkOrderValid;
}